import { WSList, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import React from "react";

import { FilterableTablePayrolls } from "../../components/TablePayrolls/FilterableTablePayrolls";
import {
  routeHelperPayrollRunsDashboardHistory,
  routeHelperPayrollRunsDetails
} from "../../paths";
import { PayrollRunsYear } from "../../types";

export const RoutePayrollRunsHistory: React.FC = () => {
  const goToDetails = routeHelperPayrollRunsDetails.useGoTo();
  const {
    params: { year: yearParam }
  } = routeHelperPayrollRunsDashboardHistory.useData();
  const year = yearParam as PayrollRunsYear;

  return (
    <WSList gap="S" mt="L">
      <WSSectionToolbar title="Payroll history" />
      <FilterableTablePayrolls
        year={year}
        onRowOpen={payrollRunId => goToDetails({ year, payrollRunId })}
      />
    </WSList>
  );
};
